import { Color, Vector2 } from 'three';
import { ResourcesManager, RoundedPlane, TextComponent, Tween, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { WINDOW_HEADER_TEXT_BACKGROUND_COLOR } from '../../styleConfig';
import { Input } from '../../components/Input';
import { InputManager } from '@verybigthings/vbt-webvr-framework/build/main/ts/utils/InputManager';
export default class SummationModule extends ViewerModule {
    constructor(gramMode = false) {
        super();
        this.expressionElementList = [];
        window.addEventListener('keyup', (event) => {
            if (!this.activeInput)
                return;
            if (!isNaN(parseInt(event.key)) || event.key === '.')
                this.activeInput.addSymbol(event.key);
            if (event.key === 'Enter')
                this.activeInput.setEnter();
            if (event.key === 'Backspace')
                this.activeInput.deleteSymbol();
        });
        this.uiObject.name = 'SummationModule';
        this.gramMode = gramMode;
        // FIRST ELEMENT =====
        if (gramMode) {
            this.firstEl = new TextComponent({
                size: new Vector2(5, 5),
                pxSize: new Vector2(256, 256).multiplyScalar(window['quality'] === 'very low' ? 0.4 : 1),
                text: {
                    style: {
                        family: 'Nunito-Sans',
                        weight: '700',
                        size: `${40 * (window['quality'] === 'very low' ? 0.4 : 1)}px`,
                        color: WINDOW_HEADER_TEXT_BACKGROUND_COLOR.getStyle()
                    },
                    lineHeight: 40 * (window['quality'] === 'very low' ? 0.4 : 1),
                    value: '58.44',
                    autoWrappingHorizontal: true,
                    align: 'center',
                    autoWrapping: true,
                    margin: {
                        left: 15 * (window['quality'] === 'very low' ? 0.4 : 1),
                        top: 10 * (window['quality'] === 'very low' ? 0.4 : 1),
                        bottom: 20 * (window['quality'] === 'very low' ? 0.4 : 1),
                        right: 15 * (window['quality'] === 'very low' ? 0.4 : 1)
                    }
                },
                background: {
                    color: new Color(0x004275).getStyle(),
                    radius: 0.07,
                }
            });
        }
        else {
            this.firstEl = RoundedPlane.getRoundedPlane({
                width: 1.2,
                height: 1.2,
                color: 0x004275,
                r1: 0.07,
            });
        }
        this.expressionElementList.push(this.firstEl);
        // OPERATION =====
        const operation = RoundedPlane.getRoundedPlane({
            width: gramMode ? 1.2 : 0.5,
            height: gramMode ? 1.2 : 0.5,
            color: 0xFFFFFF,
            r1: 0.07,
        });
        operation.material.map = ResourcesManager.getTexture(gramMode ? 'divide' : 'plus');
        this.expressionElementList.push(operation);
        // SECOND ELEMENT =====
        if (gramMode) {
            this.secondEl = new TextComponent({
                size: new Vector2(5, 5),
                pxSize: new Vector2(256, 256).multiplyScalar(window['quality'] === 'very low' ? 0.4 : 1),
                text: {
                    style: {
                        family: 'Nunito',
                        weight: '400',
                        size: `${40 * (window['quality'] === 'very low' ? 0.4 : 1)}px`,
                        color: WINDOW_HEADER_TEXT_BACKGROUND_COLOR.getStyle()
                    },
                    value: '10',
                    lineHeight: 40 * (window['quality'] === 'very low' ? 0.4 : 1),
                    autoWrappingHorizontal: true,
                    align: 'center',
                    autoWrapping: true,
                    margin: {
                        left: 15 * (window['quality'] === 'very low' ? 0.4 : 1),
                        top: 10 * (window['quality'] === 'very low' ? 0.4 : 1),
                        bottom: 20 * (window['quality'] === 'very low' ? 0.4 : 1),
                        right: 15 * (window['quality'] === 'very low' ? 0.4 : 1)
                    }
                },
                background: {
                    color: new Color(0x004275).getStyle(),
                    radius: 0.07,
                }
            });
        }
        else {
            this.secondEl = RoundedPlane.getRoundedPlane({
                width: 1.2,
                height: 1.2,
                color: 0x004275,
                r1: 0.07,
            });
        }
        this.expressionElementList.push(this.secondEl);
        if (gramMode)
            this.initInput();
        // EQUAL ========
        const equal = RoundedPlane.getRoundedPlane({
            width: gramMode ? 1.2 : 0.5,
            height: gramMode ? 1.2 : 0.5,
            color: 0xFFFFFF,
            r1: 0.06,
        });
        equal.material.map = ResourcesManager.getTexture('equals');
        this.expressionElementList.push(equal);
        // RESULT =====
        if (gramMode) {
            this.result = new TextComponent({
                size: new Vector2(5, 5),
                pxSize: new Vector2(256, 256).multiplyScalar(window['quality'] === 'very low' ? 0.4 : 1),
                text: {
                    style: {
                        family: 'Nunito-Sans',
                        weight: '700',
                        size: `${40 * (window['quality'] === 'very low' ? 0.4 : 1)}px`,
                        color: new Color(0x004275).getStyle()
                    },
                    lineHeight: 40 * (window['quality'] === 'very low' ? 0.4 : 1),
                    value: '5.8g',
                    autoWrappingHorizontal: true,
                    align: 'center',
                    autoWrapping: true,
                    margin: {
                        left: 15 * (window['quality'] === 'very low' ? 0.4 : 1),
                        top: 10 * (window['quality'] === 'very low' ? 0.4 : 1),
                        bottom: 20 * (window['quality'] === 'very low' ? 0.4 : 1),
                        right: 15 * (window['quality'] === 'very low' ? 0.4 : 1)
                    }
                },
                background: {
                    color: new Color(0x004275).getStyle(),
                    radius: 0.07,
                }
            });
        }
        else {
            this.result = RoundedPlane.getRoundedPlane({
                width: 1.2,
                height: 1.2,
                color: 0x004275,
                r1: 0.07,
            });
        }
        this.expressionElementList.push(this.result);
        this.expressionElementList.forEach(el => this.addObject(el));
        ViewerModule.adjustObjects(this.expressionElementList.map(el => el.uiObject ? el.uiObject : el), true, 0.2);
        ViewerModule.adjustObjects(this.expressionElementList.map(el => el.uiObject ? el.uiObject : el).reverse(), false, 0.2, 1);
        if (gramMode) {
            this.input.uiObject.position.y = 0.08;
            this.input.uiObject.scale.multiplyScalar(0.89);
            this.input.uiObject.name = 'input';
            this.input.uiObject.position.x = 0.32;
            this.input.uiObject.position.z = 0.03;
            this.secondEl.uiObject.position.set(0.1, -0.05, 0);
            this.secondEl.uiObject.children[0].position.set(0.1, 0.08, 0);
        }
    }
    initInput() {
        const inputOptions = {
            size: new Vector2(1.7 / 1, 1.7 / 1),
            pxSize: new Vector2(64 / 1.1, 64 / 1.1),
            background: 0x004275,
            bordRadius: 0.07,
            maxLength: 2,
            text: {
                autoWrappingHorizontal: true,
                autoWrapping: false,
                style: {
                    family: 'Nunito-Sans',
                    weight: '700',
                    size: '38px',
                    color: WINDOW_HEADER_TEXT_BACKGROUND_COLOR.getStyle()
                },
                value: '',
            }
        };
        this.input = new Input(inputOptions, 'number');
        this.input.uiObject.scale.multiplyScalar(0.9);
        this.secondEl.addObject(this.input.uiObject);
        this.input.on('onInputClicked', (event) => {
            this.activeInput = this.input;
            setTimeout(() => {
                //
                this.addObject(InputManager.keyboard);
                if (!Viewer.controls.zController) {
                    InputManager.keyboard.uiObject.position.set(0, -0.1, 9.08);
                    InputManager.keyboard.uiObject.scale.set(0.2, 0.2, 0.2);
                    // @ts-ignore
                    InputManager.keyboard.rightKeyboard.uiObject.position.x = 6;
                }
                else {
                    InputManager.keyboard.uiObject.position.set(-1.5, 3.5, 0);
                    InputManager.keyboard.uiObject.rotation.set(0, 0, 0);
                    InputManager.keyboard.uiObject.scale.setScalar(0.5);
                    // @ts-ignore
                    InputManager.keyboard.rightKeyboard.uiObject.position.x = 6;
                    // @ts-ignore
                    InputManager.keyboard.rightKeyboard.uiObject.position.z = 0;
                    // @ts-ignore
                    InputManager.keyboard.rightKeyboard.uiObject.rotation.set(0, 0, 0);
                }
            });
        });
        this.input.on('entered', () => {
            InputManager.blurInput();
            InputManager.hideKeyboard();
            if (this.input.getText() === '10') {
                this.showResult();
                this.activeInput = null;
                setTimeout(() => this.fire('successfully_entered'), 2400);
            }
            else {
                this.input.clear();
                this.input.uiObject.visible = false;
                this.fire('wrong_entered');
            }
        });
    }
    addNa() {
        if (this.gramMode) {
            const options = this.firstEl.options;
            options.text.style.color = 'yellow';
            this.firstEl.updateElement(options);
        }
        else {
            this.firstEl.material.color.setHex(0xFFFFFF);
            this.firstEl.material.map = ResourcesManager.getTexture('periodic_element_Na');
            this.firstEl.material.needsUpdate = true;
        }
        console.log('addNa');
    }
    addCl() {
        if (!this.gramMode) {
            this.secondEl.material.color.setHex(0xFFFFFF);
            this.secondEl.material.map = ResourcesManager.getTexture('periodic_element_Cl');
            this.secondEl.material.needsUpdate = true;
        }
    }
    showResult() {
        if (this.gramMode) {
            let options = this.result.options;
            options.text.style.color = WINDOW_HEADER_TEXT_BACKGROUND_COLOR.getStyle();
            this.result.updateElement(options);
        }
        else {
            this.result.material.color.setHex(0xFFFFFF);
            this.result.material.map = ResourcesManager.getTexture('periodic_element_NaCl');
            this.result.material.needsUpdate = true;
        }
    }
    flyTo(pos, time = 1000, onComplete) {
        if (Viewer.controls.zController) {
            onComplete && onComplete();
            return;
        }
        let flyAnim = new Tween(this.uiObject.position)
            .to(pos.clone(), time)
            .easing(TWEEN.Easing.Linear.None)
            .onUpdate((delta) => {
            this.uiObject.lookAt(this.controls.target.clone());
        })
            .onComplete(() => {
            console.log('fly end');
            this.uiObject.lookAt(this.controls.target.clone());
            // flyAnim.stop();
            onComplete && onComplete();
        })
            .start();
    }
    show(isVisible = true) {
        this.uiObject.visible = isVisible;
    }
}
